import { render, staticRenderFns } from "./FreteRecebidoExpedido.vue?vue&type=template&id=20688020"
import script from "./FreteRecebidoExpedido.vue?vue&type=script&lang=js"
export * from "./FreteRecebidoExpedido.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports